import { singleton } from "tsyringe";
import { IPagination } from "components/elements/InfiniteScroll";
import ClientSheetResponseResource from "common/resources/ClientSheet/ClientSheetResponseResource";
import ClientSheetCreateRequestResource from "common/resources/ClientSheet/ClientSheetCreateRequestResource";
import ClientSheetCreateBeneficiaryRequestResource from "common/resources/ClientSheet/ClientSheetCreateBeneficiaryRequestResource";
import ClientSheetCreateLegalRepresentativeRequestResource from "common/resources/ClientSheet/ClientSheetCreateLegalRepresentativeRequestResource";
import ClientSheetAddSpouseRequestResource from "common/resources/ClientSheet/ClientSheetAddSpouseRequestResource";
import ClientSheetAdminCreateMinimalRequestResource from "common/resources/ClientSheet/ClientSheetAdminCreateMinimalRequestResource";

import BaseAdminApi from "./BaseAdminApi";

@singleton()
export default class ClientApi extends BaseAdminApi {
	private baseurl = `${this.apiUrl}/clients`;

	public getLastClientSheetByClientIdAdmin(clientId: string) {
		const url = this.baseurl.concat(`/client-id/${clientId}`);
		return this.getRequest<ClientSheetResponseResource>(url);
	}

	public getClientSheetByIdAdmin(id: string) {
		const url = this.baseurl.concat(`/${id}`);
		return this.getRequest<ClientSheetResponseResource>(url);
	}

	public getClientSheetsByOfficeId(officeId: string, pagination: IPagination, search?: string | null) {
		const urlParams = new URLSearchParams();
		urlParams.append("_take", pagination.take.toString());
		urlParams.append("_skip", pagination.skip.toString());
		search && urlParams.append("_search", search ?? "");

		const url = this.baseurl.concat(`/office/${officeId}?${urlParams.toString()}`);
		return this.getRequest<ClientSheetResponseResource[]>(url);
	}

	public countByOfficeId(officeId: string) {
		const url = this.baseurl.concat(`/office/${officeId}/count`);
		return this.getRequest<{ count: number }>(url);
	}

	public postAsCreator(client: ClientSheetCreateRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/creator/${creatorId}`);
		return this.postRequest<ClientSheetResponseResource>(url, { ...client });
	}

	public createBeneficiaryAsCreator(beneficiary: ClientSheetCreateBeneficiaryRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/beneficiary/creator/${creatorId}`);
		return this.postRequest<ClientSheetResponseResource>(url, { ...beneficiary });
	}

	public createLegalRepresentativeAsCreator(legalRepresentative: ClientSheetCreateLegalRepresentativeRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/legal-representative/creator/${creatorId}`);
		return this.postRequest<ClientSheetResponseResource>(url, { ...legalRepresentative });
	}

	public addSpouseAsCreator(resource: ClientSheetAddSpouseRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/${resource.id}/spouse/creator/${creatorId}`);
		return this.postRequest<ClientSheetResponseResource>(url, { ...resource });
	}

	public createMinimalClient(resource: ClientSheetAdminCreateMinimalRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/minimal/creator/${creatorId}`);
		return this.postRequest<ClientSheetResponseResource>(url, { ...resource });
	}
}
